import { useEffect, useState } from 'react'
import type { PieChartData } from '../components/pie-chart.types'
import { Payload } from 'recharts/types/component/DefaultLegendContent'
import { getSavingsLegendPayload, getShortLegendPayload } from 'src/Libs/chart-kit/pie-charts/utils/pie-chart-legend'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useTheme } from '@mui/material'
import { UnitTypes } from 'src/Libs/types'

type UseLegendPayload = {
  legendPayload: Payload[]
}

/*
 * This hook calculates the legend payload for the pie chart
 */
export const useLegendPayload = ({
  data,
  upMd,
  isCostSavingsPieChart,
  unitType,
}: {
  data: PieChartData[]
  upMd: boolean
  isCostSavingsPieChart?: boolean
  unitType?: UnitTypes
}): UseLegendPayload => {
  const [legendPayload, setLegendPayload] = useState<Payload[]>([])
  const { t } = useCustomTranslation()
  const theme = useTheme()

  useEffect(() => {
    const newPayload = isCostSavingsPieChart ? getSavingsLegendPayload(data, t, theme) : getShortLegendPayload(data, unitType)
    setLegendPayload(newPayload)
  }, [data, upMd, isCostSavingsPieChart, t, theme, unitType])

  return { legendPayload }
}
